import { render } from "./EmployeeUpdate.vue?vue&type=template&id=1f160d28&scoped=true"
import script from "./EmployeeUpdate.vue?vue&type=script&lang=js"
export * from "./EmployeeUpdate.vue?vue&type=script&lang=js"

import "./EmployeeUpdate.vue?vue&type=style&index=0&id=1f160d28&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f160d28"]])

export default __exports__